import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=408214d8"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-load_d17de70e95606b03c19190c6e3826df1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports